<!--    this input makes form invalid if  devices accessories and supplies tabs are empty -->
<app-amount-input [ngModel]="model.someItemContainerIsActive"
                  [showIcon]="false"
                  [name]="'someItemContainerIsActiveNew'"
                  [bdMinNumber]="1"
                  class="validator-helper"
                  [forceFormValidationVisibility]="forceFormValidationVisibility"
                  #validationHelperNgModel="ngModel">
</app-amount-input>


<bd-input-error-viewer [ngModelRef]="validationHelperNgModel"
                       [customErrorsMsg]="{'isBdMinNumber': 'Bitte wählen Sie unter Schritt 3, 4 oder 5 mindestens ein Produkt aus.'}"
                       class="error-viewer">
</bd-input-error-viewer>
